<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦平台保证金管理规则</div>
    <p class="main_synopsis" style="font-weight: 600">重要提示</p>
    <p class="main_synopsis" style="font-weight: 600">
      在您使用神州邦邦平台服务前，请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和纠纷解决条款。如您对本规则有任何疑问，可向神州邦邦平台客服咨询。
    </p>
    <div class="main_item">
      <h2>第一章&nbsp;总则</h2>
      <p>
        为维护神州邦邦平台的运营管理秩序，保障神州邦邦平台用户的合法权益，明确诚信保证金相关规则，依据国家相关法律法规及神州邦邦平台相关规则制定本项规则。
      </p>
    </div>
    <div class="main_item">
      <h2>第二章&nbsp;定义</h2>
      <p>
        在本规则中所使用的词语，已有神州邦邦平台规则对其定义的从其定义，未有定义的，应具有以下含义：
      </p>
      <ul class="content_wrap1">
        <li>
          <p>
            诚信保证金：指工程师根据神州邦邦平台规则向平台缴存并同意冻结于其神州邦邦平台账户中，授权神州邦邦平台依据神州邦邦平台规则进行处置的资金。
          </p>
        </li>
        <li>
          <p>保证金额度：指工程师的保证金剩余金额。</p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第三章&nbsp;诚信保证金的基本规则</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台用户成为神州邦邦平台工程师时，必须根据《神州邦邦平台服务商入驻协议》《神州邦邦平台诚信保证金规则》等神州邦邦平台规则的约定缴纳足额的诚信保证金，否则神州邦邦平台有权拒绝该用户成为平台工程师。
          </p>
        </li>
        <li>
          <p>
            所有工程师都可以缴纳诚信保证金，并确保诚信保证金余额 ≥
            500元，若不足额时应当及时补缴，同时不可撤销地授权神州邦邦平台及其关联公司根据本规则条款及其他神州邦邦平台规则的规定处置保证金，包括但不限于保证金的收取、存储、冻结、支配使用等。
          </p>
        </li>
        <li>
          <p>
            尽管有上述约定，神州邦邦平台仍有权根据工程师业务变化及神州邦邦平台秩序管控实际需要，按照《神州邦邦平台服务协议》中约定的通知方式通知工程师，另行单独约定调整诚信保证金额度，工程师应当按此约定额度缴纳诚信保证金。
          </p>
        </li>
        <li>
          <p>
            若工程师所缴纳/补缴的诚信保证金额度不足以完全覆盖实际发生的处罚金、退款/赔付金、补偿金的部分或全部额度，则神州邦邦平台有权向工程师另行主张，包括但不限于要求工程师另行向神州邦邦平台支付款项，以覆盖实际发生的处罚金、退款/赔付金、补偿金；神州邦邦平台另行主张部分的缴纳方式由神州邦邦平台在通知时另行约定；工程师在支付神州邦邦平台另行主张部分后，仍需自行补足应当缴纳的诚信保证金额度。
          </p>
        </li>
        <li>
          <p>
            工程师补足诚信保证金额度原则上是补充差额部分，其实际补足额度应当是诚信保证金实际支出使用后的差额。
          </p>
        </li>
        <li>
          <p>
            诚信保证金不足和（或）未缴纳诚信保证金的工程师，将无法享受保证金相关权益。
          </p>
        </li>
        <li>
          <p>
            工程师缴纳的保证金将自动储存并冻结于其神州邦邦平台账户内，并在诚信保证金专项管理界面显示其缴纳额度，同时在工程师个人主页页显示其已缴纳诚信保证金及诚信保证金额度或类似标识。
          </p>
        </li>
        <li>
          <p>诚信保证金主要用途有以下四种：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                工程师违反国家法律法规及/或神州邦邦平台规则，根据规则内的处理规定进行扣除的情况，诚信保证金作为处罚金。
              </p>
            </li>
            <li>
              <p>
                工程师因纠纷案件导致退款/赔付，雇主在向工程师直接诉求未及时处理或未果，转而诉求神州邦邦平台，神州邦邦平台用于退款/赔付的情况，诚信保证金作为退款/赔付金。
              </p>
            </li>
            <li>
              <p>
                工程师因争议纠纷案件或法律诉讼，被判定工程师应当担责（包括全责或部分责任），导致神州邦邦平台及其关联公司使用自有资金赔付或代工程师提前赔付，工程师用于补偿神州邦邦平台及其关联公司赔付损失的情况，诚信保证金作为补偿金。
              </p>
            </li>
          </ul>
          <p style="font-weight: 600">
            除以上三种用途外，工程师的诚信保证金还将用于神州邦邦平台规定的其他合法用途。
          </p>
        </li>
        <li>
          <p>工程师保证金权益</p>
          <ul class="content_wrap2">
            <li>
              <p>
                专属标识点亮：工程师缴纳保证金后，个人账户信息可点亮专属标识，作为平台认证的服务质量保障，区别于未缴纳保证金工程师。
              </p>
            </li>
            <li>
              <p>
                每单定额补贴：即日起至2022年6月30日，对于缴纳保证金的工程师，单笔金额>=100元的订单，完成交付后可享受5元/笔的定额补贴。（客户指定派单及其他特定订单除外）
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            工程师满足条件可以通过诚信保证金专项管理页面申请退出诚信保证金，具体条件是：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>无在服务中订单</p>
            </li>
            <li>
              <p>无质保期内订单</p>
            </li>
            <li>
              <p>无售后纠纷订单</p>
            </li>
          </ul>
          <p>
            以上条件任何一条不满足，神州邦邦平台有权拒绝工程师退出诚信保证金。
          </p>
        </li>
        <li>
          <p>工程师退出的诚信保证金将按照原支付的路径退回到原支付账户中。</p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第四章&nbsp;诚信保证金的缴纳/补缴、支配使用细则</h2>
      <p>诚信保证金的支配使用</p>
      <ul class="content_wrap1">
        <li>
          <p>
            已缴纳诚信保证金的工程师不可撤销的授权神州邦邦平台及其关联公司根据本规则条款及其他神州邦邦平台规则的规定处置保证金，包括但不限于保证金的收取、存储、冻结、支配使用等。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台在本规则规定的具体情况下，将以扣除的方式处置工程师的诚信保证金，具体情况如下：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                工程师违反国家法律法规及/或神州邦邦平台规则时，神州邦邦平台将按照相关规则约定扣除一定或全部的诚信保证金用于处理。
              </p>
            </li>
            <li>
              <p>
                工程师被雇主举报或发起官方介入调解，经调解判断担责且需要退款/赔付，在雇主直接向工程师诉求未及时处理或未果时，神州邦邦平台将扣除一定或全部的诚信保证金用于退款/赔付给雇主。
              </p>
            </li>
            <li>
              <p>
                工程师因纠纷案件或法律诉讼，被判定工程师担责（包括全责或部分责任），导致神州邦邦平台及其关联公司使用自有资金赔付或代工程师提前赔付时，神州邦邦平台将扣除一定或全部的诚信保证金用于补偿神州邦邦平台赔付损失。
              </p>
            </li>
            <li>
              <p>工程师同意并合理请求神州邦邦平台进行处置的。</p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            神州邦邦平台在扣除处置诚信保证金时，将以《神州邦邦平台服务协议》中约定的通知方式通知到工程师，在向工程师出具的通知中，将说明扣除原因及扣除金额，通知发出时将立即予以执行。
          </p>
        </li>
        <li>
          <p>
            针对神州邦邦平台使用诚信保证金退款/赔付给雇主的处置情况，另做以下特别约定：
          </p>
          <p>一、当雇主与非神州邦邦平台指定主体授权的工程师进行交易时：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                若该笔纠纷订单的款项尚未进入到工程师的神州邦邦平台账户中（即工程师尚未收款），神州邦邦平台优先直接代替工程师操作退款/赔付，其次使用诚信保证金进行退款/赔付，再次使用账户余额进行退款/赔付；
              </p>
            </li>
            <li>
              <p>
                若该笔纠纷订单的款项已进入到工程师的神州邦邦平台账户中（即工程师已经收款），神州邦邦平台优先使用诚信保证金进行退款/赔付，在保证金不足额时，将划扣工程师的神州邦邦平台账户余额补足退款/赔付；其次直接使用工程师的神州邦邦平台账户余额进行退款/赔付。
              </p>
            </li>
            <li>
              <p>
                工程师的账户余额都不足以覆盖退款/赔付给雇主的全部金额时，神州邦邦平台将通知工程师自行承担仍未覆盖的退款/赔付金额部分，工程师应当承担该项义务，自行支付该部分金额；
              </p>
            </li>
            <li>
              <p>
                工程师应当明确了解并同意，在工程师的账户余额不足以覆盖退款/赔付给雇主的全部金额时，神州邦邦平台有权但无义务使用自有资金退款/赔付给雇主。一旦神州邦邦平台使用自有资金退款/赔付给雇主，神州邦邦平台有权向工程师索偿，工程师应当在收到神州邦邦平台通知后的7个自然日内偿还神州邦邦平台该笔资金，否则神州邦邦平台有权中止对工程师的服务并处置工程师的账户余额及/或在途收入资金以补偿，若仍不足的，神州邦邦平台有权通过其他合法途径继续追偿；
              </p>
            </li>
            <li>
              <p>
                神州邦邦平台使用自有资金退款/赔付给雇主，其金额仅以涉及纠纷的单次交易中雇主通过神州邦邦平台实际向工程师支付的金额减去工程师的平台账户内可支配诚信保证金的金额为限。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            针对神州邦邦平台使用诚信保证金偿还贷款本金、利息、罚息或其它相关费用，使用诚信保证金补偿神州邦邦平台及其关联公司使用自有资金赔付或代工程师提前赔付纠纷或法律诉讼索偿的损失金额的处置情况，另做以下特别约定：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                神州邦邦平台优先使用诚信保证金额度进行代偿或补偿损失，在保证金不足额时，将划扣工程师的神州邦邦平台账户余额补足；
              </p>
            </li>
            <li>
              <p>
                若工程师的神州邦邦平台账户余额不足以覆盖偿还或补偿损失金额，神州邦邦平台有权中止对工程师的服务并处置工程师的账户余额及/或在途收入资金以偿还/补偿损失，若仍不足的，神州邦邦平台有权通过其他合法途径继续追偿。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            针对神州邦邦平台使用诚信保证金作为处罚金的处置情况，另做以下特别约定：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                神州邦邦平台优先使用诚信保证金额度进行处理，在保证金不足额时，不会划扣工程师的神州邦邦平台账户余额；
              </p>
            </li>
            <li>
              <p>
                工程师诚信保证金额度不足以覆盖处罚金额时，神州邦邦平台将中止对工程师的服务，直到工程师补缴足额的诚信保证金为止；
              </p>
            </li>
            <li>
              <p>
                若工程师明确拒绝补缴足额的诚信保证金，神州邦邦平台将终止对工程师的服务，并保留继续追偿的权利。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            工程师对雇主、任何第三方、神州邦邦平台及其关联公司的退款、赔付、代偿、补偿责任不以工程师已缴纳的保证金额度为限；神州邦邦平台对工程师的处罚金额也将不以工程师已缴纳的保证金额度为限。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第五章&nbsp;授权委托</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            本规则一旦生效，即表示工程师已充分理解并同意向神州邦邦平台作出授权，工程师授权神州邦邦平台对其神州邦邦平台账户中的诚信保证金、余额进行相应操作，此授权为不可撤销授权。
          </p>
        </li>
        <li>
          <p>
            根据本规则的约定，神州邦邦平台有权对工程师的神州邦邦平台账户进行如下类型的操作：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>保证金的收缴、冻结、解冻及按照本规则所列的用途处置保证金；</p>
            </li>
            <li>
              <p>
                纠纷订单的款项尚未进入到工程师的神州邦邦平台账户中（即工程师尚未收款），神州邦邦平台可代替工程师操作退款/赔付；
              </p>
            </li>
            <li>
              <p>
                在保证金额度不足时，划扣神州邦邦平台账户中的余额以抵扣退款/赔付金；
              </p>
            </li>
            <li>
              <p>
                工程师的神州邦邦平台账户余额不足以覆盖保证金的所有或部分用途所需金额，神州邦邦平台有权中止/终止对工程师的服务并处置工程师的神州邦邦平台账户内的余额及/或在途收入资金。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第六章&nbsp;责任约定</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台未行使本规则约定之权利的，不视为神州邦邦平台的弃权行为。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台基于本规则享有的权利以及获得的授权，均可以全部或部分转移、转让、许可、分授权、转授权给任何第三方行使。未经神州邦邦平台事先书面同意，工程师不得将本规则项下的权利义务转让给任何第三方。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台在因纠纷的情况下处置诚信保证金时，您应当了解并明确同意神州邦邦平台及其关联公司并非司法机构，仅能以普通或非专业人员的知识水平标准对规则方提交的证据材料进行鉴别，神州邦邦平台及其关联公司对纠纷的调处完全是基于您的委托，神州邦邦平台及其关联公司无法保证纠纷处理结果符合交易双方的期望，也不对纠纷调处结果及保证金的划扣决定承担任何责任。如您因此遭受损失，您同意自行向受益人索赔，神州邦邦平台应予以免责。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第七章&nbsp;规则的变更</h2>
      <p>
        神州邦邦平台可根据国家法律法规变化、神州邦邦平台商业模式的调整及维护交易秩序、保护消费者权益需要，不时修改本规则、补充规则，变更后的规则、补充规则（下称“变更事项”）将通过法定程序并以《神州邦邦平台服务协议》第九章约定的方式通知您。
      </p>
      <p>
        如您不同意变更事项，您有权于变更事项确定的生效日前联系神州邦邦平台反馈意见。如反馈意见得以采纳，神州邦邦平台将酌情调整变更事项。
      </p>
      <p>
        如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用神州邦邦平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用神州邦邦平台服务，则视为您同意已生效的变更事项。
      </p>
    </div>
    <div class="main_item">
      <h2>第八章&nbsp;法律适用、管辖与其他</h2>
      <p>
        本规则之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
      </p>
      <p>
        您因使用神州邦邦平台服务所产生及与神州邦邦平台服务有关的争议，由神州邦邦平台与您协商解决。协商不成时，任何一方均可向北京仲裁委员会提起仲裁。
      </p>
      <p>
        本规则任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本规则其余条款的有效性及可执行性。
      </p>
    </div>
    <div class="main_item">
      <h2>神州邦邦平台对本规则拥有最终解释权</h2>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>